module.exports = __webpack_public_path__ + "static/media/logo_dosi.6090f3e7.png";